import React, { Component } from 'react'
import InputField from '../../components/uiKit/InputField'
import Button from '../../components/uiKit/Button'
import { withRouter} from 'react-router-dom'  
import Icon from '../../components/misc/Icons'
import {Image} from 'cloudinary-react'

const maxNameLength = 80  
const maxDescriptionLength = 300 


class EditRepoModal extends Component {
  
	constructor(props){
		super(props)
		this.onPaste=this.onPaste.bind(this)
	 
	}


	componentDidMount(){
		if(!this.props.repo){
			var input = document.getElementById('repoNameInput')
			input.focus()
			input.select()
		}

		if(window.analytics){
			if(this.props.repo){
				window.analytics.page('Edit Repo Modal',{repoId:this.props.repo.id})
			}else{
				window.analytics.page('New Repo Modal')
			}
			
		}

	}


		
	handleRepoDescriptionKeyDown(e){
		if(e.which === 13) { //prevent line breaks
			e.preventDefault()
		}
	}

	onPaste(event) {
	    event.preventDefault()//prevent pasting
    	var newText = (event.originalEvent || event).clipboardData.getData('text/plain')
    	newText = newText.replace(/\r?\n/g, ' ') //remove line breaks

      	// merged the modified pasted text with the existing text
	    var el = event.target
	    var cursorPosStart = el.selectionStart
	    var cursorPosEnd = el.selectionEnd
	    var v = el.value
	    var textBefore = v.substring(0, cursorPosStart)
	    var textAfter  = v.substring(cursorPosEnd, v.length)
	    let mergedText = textBefore + newText + textAfter
	    el.value=mergedText
	    if(mergedText.length >= maxDescriptionLength) {
			mergedText=mergedText.substring(0, maxDescriptionLength)
		}

	    this.props.updateRepoDescription(mergedText)


	}


	render() {
		const {repo,repoName,repoImage,repoDescription,imageToUploadOnCreate,submitButtonDisabled}=this.props
		const uploadingImage = this.props.uploadingToCloudinary


		return ( 
			<div className='repoDetailsModal'>
				<div className='repoDetailsModal-closeBtn' onClick={this.props.hideModal}>					
 					<Icon name='circle-with-close' /> 
				</div>

				<div className='repoDetailsModal-title'>
					{!repo &&
						<span>Create New Pack</span>
					}
					{repo &&
						<span>Edit Pack</span>
					}
				</div>

				{/* REPO NAME */}
				<div className='repoDetailsModal-input repoDetailsModal-input--name'>
					<div className='repoDetailsModal-input-label'>
						Name 
						
						<div className={'repoDetailsModal-input-label-characterCount ' + ((maxNameLength === repoName.length) ? ' repoDetailsModal-input-label-characterCount--max' : '') + ((repoName.length > 60) ? ' repoDetailsModal-input-label-characterCount--show' : '')}>
							{repoName.length} / {maxNameLength}
						</div>				

					</div>
					<InputField
						autoFocus={true} 
						onFocus={function(e) {
		    				var val = e.target.value
		    				e.target.value = ''
		    				e.target.value = val
		 	 			}}		      
						value={repoName}
						placeholder='Enter Pack Name'
						maxLength={maxNameLength}
						onChangeFunction={this.props.handleNameChange}
						id={'repoNameInput'}

					/>
				</div>

				<div className='repoDetailsModal--middle'>

					{/* REPO IMAGE */}
					<div className='repoDetailsModal-image' >
						<div className='repoDetailsModal-input-label'>
							Image
						</div>


						{!repoImage &&	!uploadingImage  && !imageToUploadOnCreate &&
								<div className='repoDetailsModal-imageContainer repoDetailsModal-imageContainer--noImage' onClick={this.props.showEditImageModal}>
									<div className='repoDetailsModal-imageContainer-addImage'>
										<Icon name='plus' />
									</div>			
								</div>
						}

						{repoImage && !uploadingImage &&
								<div className='repoDetailsModal-imageContainer repoDetailsModal-imageContainer--hasImage'>
									<div onClick={this.props.deleteImage} className='repoDetailsModal-imageContainer-removeImage'>
										<Icon name='close' />
									</div>

									<Image
										cloudName={process.env.REACT_APP_CLOUDINARY_CLOUDNAME}
										publicId={`${repoImage}/repo/${repo.id}`} 
										className='repoDetailsModal-imageContainer-image'
										width='450'
										height='450'
										crop='fill'
									/>

									<div className='repoDetailsModal-imageContainer-image-border'/>
								</div>
							}

							{!repoImage && !uploadingImage && imageToUploadOnCreate &&
								<div className='repoDetailsModal-imageContainer repoDetailsModal-imageContainer--noImage'>
									<div onClick={this.props.deletePendingImage} className='repoDetailsModal-imageContainer-removeImage'>
										<Icon name='close' />
									</div>

									<img src={imageToUploadOnCreate} alt=''
										className='repoDetailsModal-imageContainer-image'
									/>

									<div className='repoDetailsModal-imageContainer-image-border'/>
								</div>
							}



							{uploadingImage && !repoImage &&
								<div className='repoDetailsModal-imageContainer repoDetailsModal-imageContainer--uploadingImage'>
									<div className='repoDetailsModal-imageContainer--uploading-loadingSpinnerContainer'>
										<div className='repoDetailsModal-imageContainer--uploading-loadingSpinner' />
									</div>									
								</div>
							}						
						
					</div>


					{/* REPO DESCRIPTION */}
					<div className='repoDetailsModal-input repoDetailsModal-input--description'>
						<div className='repoDetailsModal-input-label'>
							Description

							<div className={'repoDetailsModal-input-label-characterCount ' + ((maxDescriptionLength === repoDescription.length) ? ' repoDetailsModal-input-label-characterCount--max' : '') + ((repoDescription.length > 200) ? ' repoDetailsModal-input-label-characterCount--show' : '')}>
								{repoDescription.length} / {maxDescriptionLength}
							</div>				

						</div>
						<textarea
							onFocus={function(e) {
			    				var val = e.target.value
			    				e.target.value = ''
			    				e.target.value = val
			 	 			}}		      
							value={repoDescription}
							onPaste={this.onPaste}
							className={"" + ((repoDescription.length === 0) ? " is--empty" : " is--nonEmpty")}			      
							placeholder='Give your pack a snazzy description'
							onChange={this.props.handleDescriptionChange}
							maxLength={maxDescriptionLength}
							onKeyDown={this.handleRepoDescriptionKeyDown}
						/>
					</div>

				</div>
			
				{/* REPO SUBMIT BUTTON */}
				<Button 
					label={repo ? 'Done' : 'Create Pack'}
					size='xLarge'
					name='repoDetailSubmit'
					inputType='submit'
					disabled={this.props.submitLoading}
					submitLoading={this.props.submitLoading} 
					color={submitButtonDisabled ? 'gray' : 'blue'}
					onClickFunction={repo ? this.props.updateRepo : this.props.createRepo}
				/>

				

			</div>
		)
	}
}


export default withRouter(EditRepoModal)






// WEBPACK FOOTER //
// ./src/components/repo/EditRepoModal.js